export default __webpack_public_path__ + "static/media/back_rand4.fd5fca42.jpg";